export default __webpack_public_path__ + "4db19918ba01b7c4c2c16ca49dde326e.png";